module.exports = __webpack_public_path__ + "b2d290af.png";